/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const budgetPriority = useStore((state) => state.budgetPriority);
  const setBudgetPriority = useStore((state) => state.setBudgetPriority);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.budgetPriority.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={budgetPriority}
          onChange={(value) => {
            setBudgetPriority(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'budget-priority',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'yes'}>
            <span>👍</span> {t('onboarding.budgetPriority.options.yes')}
          </Option>
          <Option value={'no'}>
            <span>🎯</span> {t('onboarding.budgetPriority.options.no')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
